import React from 'react';

import { InlineNotification } from '@/features/execute-calculation-set/components/Calculation/InlineNotification';

export function InlineError(props: { text: string }) {
  return (
    <div className="h100 w100 jcC aiC beta fdC">
      <InlineNotification type="ERROR" className="mAl" content={props.text} />
    </div>
  );
}
